export default __webpack_public_path__ + "static/10-cb09677081c7836c3c60f368200d1bfa.png";